import React from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import PropTypes from 'prop-types'

/**
 * Reusable search input component with an integrated clear button
 *
 * Features:
 * - Clear button appears inside the input box on the right side
 * - Clear button is always visible (grayed out when input is empty)
 * - Clicking clear button clears the input value
 * - Supports all standard Form.Control props
 */
const SearchInputWithClear = ({
    value,
    onChange,
    onClear,
    placeholder = 'Search...',
    className = '',
    ...otherProps
}) => {
    const handleClear = () => {
        if (onClear) {
            onClear()
        }
    }

    return (
        <div className="position-relative" style={{ width: '100%' }}>
            <Form.Control
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={className}
                style={{ paddingRight: '35px' }} // Make room for the clear button
                {...otherProps}
            />
            <button
                type="button"
                onClick={handleClear}
                className="btn btn-link position-absolute"
                style={{
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    color: value ? '#6c757d' : '#dee2e6',
                    cursor: value ? 'pointer' : 'default',
                    fontSize: '18px',
                    lineHeight: '1',
                    border: 'none',
                    background: 'transparent',
                    opacity: value ? 1 : 0.5,
                    transition: 'color 0.2s ease, opacity 0.2s ease'
                }}
                disabled={!value}
                aria-label="Clear search"
                title="Clear search"
            >
                ✕
            </button>
        </div>
    )
}

SearchInputWithClear.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
}

export default SearchInputWithClear
